<template>
  <div>
    <Header></Header>
    <main>
      <div class="section section-alpha">
        <div class="container">
          <h1>Privacy policy</h1>
          <p>
            Privacy notice for participants in health and care research Version
            6
          </p>
        </div>
      </div>
      <div class="section section-beta">
        <div class="container">
          <h2>General information</h2>
          <p>
            University College London (UCL) aims to conduct research to the
            highest standards of research integrity. Our research is underpinned
            by policies and procedures that ensure we comply with regulations
            and legislation that govern the conduct of research; this includes
            data protection legislation such as the General Data Protection
            Regulation (GDPR) and the Data Protection Act 2018 (DPA).
          </p>
          <p>
            UCL uses personal data to conduct research to improve health, care
            and services. As a publicly-funded organisation incorporated under a
            Royal Charter, we ensure that it is in the public interest when we
            use personal data from people who have agreed to take part in
            research. This means that when you agree to take part in a research
            study, we will use your personal data in the ways needed to conduct
            and analyse the research study.
          </p>
          <p>
            Health and care research should serve the public interest, which
            means that we have to demonstrate that our research serves the
            interests of society as a whole. Most of our health and care
            research follows the UK Policy Framework for Health and Social Care
            Research.
          </p>
          <h2>What is research?</h2>
          <p>
            Research has a special status under data protection legislation. It
            is important therefore to specify what we mean by research. It is
            generally understood by universities that research makes an original
            contribution to knowledge. Research conducted by our staff and
            postgraduate research students is always intended to make an
            original contribution to knowledge. Such research is published in
            order to share that knowledge.
          </p>
          <p>
            Research projects may also be conducted by undergraduate and taught
            postgraduate i.e. Masters in Arts/Science etc. students to fulfil
            the requirements of their programme of study. These projects are not
            necessarily intended to make an original contribution to knowledge
            and are not usually published. However, this research is integral to
            the students education and for the purpose of this privacy notice
            these projects are included within the definition of research.
          </p>
          <p>
            Some research may be conducted in collaboration with commercial
            organisations and funders.
          </p>
          <h2>
            What is Personal Data - also referred to as a personal information?
          </h2>
          <p>
            Personal data; means any information which relates to or identifies
            an individual. This includes information which may not explicitly
            identify you e.g. where your name has been removed but which does
            make it possible to identify you if it is combined with other
            information that is readily available. For example, this might be
            because the information available contains a postcode, your gender
            and date of birth; in these circumstances it might be possible to
            identify you by using other information available elsewhere.
            Therefore, in these circumstances, we would treat the details we
            hold as personal information and protect it accordingly.
          </p>
          <p>
            We promise to respect the confidentiality of the personal
            information that you, as a participant in our research, provide to
            us; that we get from other organisations; and that we share with
            other collaborating organisations, such as other universities or our
            research funders. We will be clear with you when we collect your
            information how we intend to use it. We will not do anything with
            your personal information that you wouldn’t reasonably expect.
          </p>
          <p>
            We will use your information only for the purpose of the research
            you are participating in and we will not usually use your
            information or contact you for any purpose other than research
            unless you have agreed to this.
          </p>
          <p>
            We commit to keeping your personal information secure.
          </p>
          <h2>Who is responsible for my personal information?</h2>
          <p>
            When we manage research projects, we will usually be the controller,
            which means that we will decide how your personal information is
            created, collected, used, shared, stored and deleted - processed. We
            will do so in line with the objectives of the research, ensuring we
            collect only what is appropriate and necessary and we have informed
            you of what we are collecting.
          </p>
          <p>
            For some research projects, the organisation funding the research
            may make decisions regarding your information. If this is the case,
            this will be made clear in the participant information sheet
            provided to you. There are instances where two or more controllers
            work together on a research project. When this happens, the
            organisations have agreements and/or contractual arrangements in
            place which document how they have agreed to share their
            responsibilities. In these circumstances this will be detailed in
            the Participant Information Sheet, you will be given.
          </p>
          <h2>
            What personal information do we use within research projects and
            where do we get it from?
          </h2>
          <p>
            The type of personal information collected and used will depend on
            the particular research objectives of the project you are taking
            part in. Depending on the study we may collect personal information
            directly from you or we may collect it from third parties for
            example, GP records, hospital records. Whatever personal information
            we collect and no matter where we collect it from, it will always be
            proportionate to achieving those objectives.
          </p>
          <h3>Personal information that we collect from you</h3>
          <p>
            Where we collect personal information from you directly, a
            Participant Information Sheet and/or Privacy Notice will inform you
            about what information we are using and how we are going to use it.
            We often ask you for your informed consent when we contact you
            directly.
          </p>
          <h3>Personal information that we collect from other sources</h3>
          <p>
            Where it is not possible or practical to contact you directly and
            obtain your consent, we seek approval from the NHS Health Research
            Authority’s Confidentiality Advisory Group - CAG to obtain your
            personal information directly from the NHS under a Section 251
            Exemption.
          </p>
          <p><strong>Section 251 and the NHS</strong></p>
          <p>
            Section 251 of the NHS Act 2006 came about as it was recognised that
            there were activities of medical research that required the use of
            personal information however, because patient consent had not been
            obtained to use patients&amp;r confidential information for these
            other purposes, there was no secure basis in law for doing so.
          </p>
          <p>
            Section 251 enables the common law duty of confidentiality to be
            lifted to enable disclosure of confidential patient information for
            medical purposes, where it was not possible to use anonymised
            information and where seeking consent was not practical.
          </p>
          <p>
            For information about the CAG and Section 251, please visit the
            <a
              href="http://www.hra.nhs.uk/about-us/committees-and-services/confidentiality-advisory-group/"
            >
              Health Research Authority website</a
            >.
          </p>
          <p>
            To find out what choices are available in the way the NHS uses your
            health records, including opting out, please visit the
            <a href="http://www.nhs.uk/your-nhs-data-matters/"> NHS website</a>.
          </p>
          <h3>Special category and criminal convictions personal data</h3>
          <p>
            UCL may process some information about you that is considered to be
            ‘sensitive’, this is called ‘special category personal data’. This
            includes information concerning your ethnicity; sexual orientation;
            gender identity, specifically whether your gender identity is the
            same as the gender originally assigned to you at birth; your
            religious beliefs; or details about your health. These types of
            personal information requires additional protections.
          </p>
          <p>
            For specific research projects, other sensitive information may be
            used, such as information about past criminal convictions. This
            will, of course, be for a research project dedicated and relevant to
            that field. Access to, and the sharing of, this more sensitive
            personal data is controlled very carefully and you will be
            specifically informed about this in your participant information
            sheet. Your information will usually be shared within the research
            team conducting the project you are participating in.
          </p>
          <p>
            You will be made aware in the Participant Information Sheet if there
            are collaborators that are not employed by the University who will
            also access your information.
          </p>
          <p>
            All our researchers are asked to de-identify ,anonymise,
            pseudonymise ,remove identifiers such as your name and replace this
            with a unique code or key or delete personal information collected
            as part of their research at the earliest opportunity.
          </p>
          <p>
            All personal information is kept in line with our policies or any
            regulatory requirements.
          </p>
          <p>
            Information relating to healthcare professionals and others involved
            in setting up and conducting research studies
          </p>
          <h3>Research study participants</h3>
          <p>
            The type of personal information collected and used will depend on
            the particular research objectives of the study a participant is
            taking part in.
          </p>
          <p>
            Depending on the study, we may collect personal information directly
            from the participant or we may collect it from third parties for
            example, GP records and hospital records.
          </p>
          <p>
            Whatever personal information we collect and no matter where we
            collect it from, it will always be proportionate to achieving those
            objectives. When we collect personal information from a participant
            directly, a Participant Information Sheet and/or Privacy Notice will
            inform the participant about what information we are using and how
            we are going to use it.
          </p>
          <p>
            We often ask participants for their informed consent to use of their
            personal data for the purpose of the research study when we contact
            them directly.
          </p>
          <h3>Researchers</h3>
          <p>
            For each research study in respect of which UCL is the study sponsor
            or otherwise managing the research project, UCL will collect
            personal data e.g. names, contact details, CVs, training records
            about the researchers, being:
          </p>
          <ul>
            <li>
              Doctors, nurses and other staff involved in the recruitment,
              diagnosis, and treatment of participants taking part in the
              research study.
            </li>
            <li>
              Laboratory staff, company employees, and staff from other
              organisations that are supporting and/or funding the research
              study.
            </li>
            <li>
              Members of the public who contribute to the design and conduct of
              the research study, including individuals that sit on relevant
              local working groups or committees.
            </li>
            <li>
              Healthcare professionals who contribute to the trial management
              groups and oversight committees that oversee the research study.
            </li>
          </ul>
          <p>
            UCL will collect researcher personal data for the core purpose of
            carrying out the research study either directly from the researcher
            for example, via the staff signature and delegation of
            responsibilities log or indirectly from public sources or the
            study's source data.
          </p>

          <h2>
            What safeguards do we have in place to protect your personal
            information?
          </h2>

          <p>
            In order to protect your rights and freedoms when using your
            personal information for research and to process special category
            information the University must have special safeguards in place to
            help protect your information. We have the following safeguards:
          </p>

          <ul>
            <li>
              Policies and procedures that tell our staff and students how to
              collect and use your information safely.
            </li>
            <li>
              Training which ensures our staff and students understand the
              importance of data protection and how to protect your data.
            </li>
            <li>
              Security standards and technical measures that ensure your
              information is stored safely and securely.
            </li>
            <li>
              All research projects involving personal data are scrutinised and
              approved by a research ethics committee.
            </li>
            <li>
              Contracts with companies or individuals not associated with the
              University have confidentiality clauses to set out each party’s
              responsibilities for protecting your information.
            </li>
            <li>
              We carry out data protection impact assessments on high risk
              projects to ensure that your privacy, rights as an individual or
              freedoms are not affected.
            </li>
            <li>
              If we use collaborators outside of Europe, we will ensure that
              they have adequate data protection laws or are part of privacy and
              security schemes such as the privacy shield in the US.
            </li>
          </ul>

          <p>
            In addition to the above University safeguards the data protection
            legislation also require us to meet the following standards when we
            conduct research with your personal information:
          </p>

          <ul>
            <li>
              the research will not cause damage or distress to someone e.g.,
              physical harm, financial loss or psychological pain.
            </li>
            <li>
              the research is not carried out in order to do or decide something
              in relation to an individual person, unless the processing is for
              medical research approved by a research ethics committee.
            </li>
            <li>
              the Data Controller has technical and organisational safeguards in
              place e.g. appropriate staff training and security measures.
            </li>
            <li>
              if processing a special category personal data, this must be
              subject to a further public interest test to make sure this
              particularly sensitive information is required to meet the
              research objectives.
            </li>
          </ul>

          <h2>The lawfulness of using your personal data</h2>
          <p>
            Data protection legislation requires us to have a valid legal reason
            to process and use personal data about you. This is often called a
            ‘legal basis’. GDPR requires us to be explicit with you about the
            legal basis upon which we rely in order to process information about
            you. In the context of research, the lawful basis upon which we will
            process your personal information is usually where “<em
              >Processing is necessary for the performance of a task carried out
              in the public interest or in the exercise of official authority
              vested in the controller</em
            >” - Article 6 of GDPR:
          </p>
          <p>
            Where we also collect and use sensitive personal information -
            special category personal data we only do so where:
          </p>
          <p>
            <em
              >“the processing is necessary for archiving purposes in the public
              interest, scientific or historical research purposes or
              statistical purposes... which shall be proportionate to the aim
              pursued, respect the essence of the right to data protection and
              provide for suitable and specific measures to safeguard the
              fundamental rights and the interests of the data subject”.
            </em>
          </p>
          <p>
            Article 9 of GDPR. Personal data relating to criminal convictions
            must also be treated with extra care and Schedule 1 of the Data
            Protection Act 2018 provides a specific condition to allow it to be
            collected for research purposes if the special safeguards are in
            place.
          </p>
          <p>
            Where we need to rely on a different legal condition, such as
            consent, we will inform you of this in the Participant Information
            Sheet provided to you.
          </p>
          <p>
            In some studies, for example, we may use the following condition:
          </p>
          <p>
            “<em
              >Processing is necessary for the purposes of preventive or
              occupational medicine, for the assessment of the working capacity
              of the employee, medical diagnosis, the provision of health or
              social care or treatment or the management of health or social
              care systems and services on the basis of Union or Member State
              law or pursuant to contract with a health professional and subject
              to the conditions and safeguards</em
            >”.
          </p>
          <h2>Who will my personal information be shared with?</h2>

          <p>
            Your information is likely to be shared within the project team,
            primarily in a way that we can identify you as a participant,
            however most personal information used in research will be
            psuedeonymised before sharing more widely or publishing the research
            outcomes.
          </p>
          <p>
            It may sometimes be necessary to share your personal information
            with other researchers for the purpose of achieving the research
            outcomes. If this is relevant to the research you are involved with,
            you will be provided with information about this in your Participant
            Information Sheet. If you have any further questions about research
            collaborations please contact the research team you are involved
            with.
          </p>
          <p>
            If we are working with other organisations and information is shared
            with them, we will inform you in the Participant Information Sheet.
          </p>
          <p>
            Information shared will be on a need to know basis, not excessive
            and with all appropriate safeguards in place to ensure the security
            of your information. We also sometimes use products or services
            provided by third parties who carry out a task on our behalf or used
            for sharing research data for collaboration. These third parties are
            known as data processors and when we use them we have contractual
            terms, policies and procedures to ensure confidentiality is
            respected. This does not always mean that they access your
            information.
          </p>
          <p>
            The University remains responsible for your personal information as
            the controller and should researchers use another third party
            service to process personal your information they will provide you
            with details about the relationship they have with the service
            provider / supplier/collaborator on the Participant Information
            Sheet.
          </p>
          <p>
            Your personal information will only be used for the purpose of
            health and care research, and cannot be used to contact you or to
            affect your care. It will not be used to make decisions about future
            services available to you.
          </p>
          <h2>Your rights</h2>
          <p>
            Under data protection legislation you have individual rights in
            relation to the personal information we hold about you. For the
            purposes of research where such individual rights would seriously
            impair research outcomes, such rights are limited.
          </p>
          <p>
            However, under certain circumstances, these include the right to:
          </p>
          <ul>
            <li>access your personal information</li>
            <li>correct any inaccurate information</li>
            <li>erase any personal information</li>
            <li>
              restrict or object to our processing of your information
            </li>
            <li>move your information -“portability”</li>
          </ul>
          <p>
            It is important to understand that the extent to which these rights
            apply to research will vary and that in some circumstances rights
            may be restricted. If it is considered necessary to refuse to comply
            with any of your individual rights, you will be informed of the
            decision within one month and you also have the right to complain
            about our decision to the Information Commissioner.
          </p>
          <p>
            It should also be noted that we can only implement your rights
            during the period upon which we hold personal identifiable
            information about you.
          </p>
          <p>
            Once the information has been irreversibly anonymised and becomes
            part of the research data set it will not be possible to access your
            personal information.
          </p>
          <h2>For how long is my information kept?</h2>
          <p>
            We ask our researchers to de-identify information wherever possible
            ,anonymisation or pseudonymisation. Information where you can be
            identified will, as such, be kept for a minimum amount of time and
            in accordance with the research objectives.
          </p>
          <p>
            We may, however, keep consent forms which contain personal
            information for a number of years after the research has been
            completed, as this is sometimes a requirement the research’s funder.
          </p>
          <p>
            Further details about how long personal information obtained for
            research is kept can be found in our
            <a href="https://www.ucl.ac.uk/library/docs/retention-schedule.pdf">
              retention schedule</a
            >.
          </p>
          <p>
            For some research projects we cannot de-identify the information as
            it is necessary for achieving the outcome of the research. For such
            projects, we store your personal information as part of the research
            for the duration of the project and for a defined period after the
            project has ended. This is usually defined by external regulations
            but may be defined by our own policies and procedures.
          </p>
          <p>
            You will be informed in your Participant Information Sheet with
            regards to how long your personal information will be kept for.
          </p>
          <h2>Who can I contact?</h2>
          <p>
            If you have any questions about how your personal information is
            used, or wish to exercise any of your rights, please consult the
            <a href="https://www.ucl.ac.uk/data-protection/">
              University’s data protection webpages</a
            >.
          </p>
          <p>
            If you need further assistance, please contact the University’s Data
            Protection Officer -
            <a href="mailto:dataprotection@ucl.ac.uk"
              >dataprotection@ucl.ac.uk</a
            >
          </p>
          <p>
            You can contact UCL by telephoning +44 20 7679 2000 or by writing
            to: University College London, Gower Street, London WC1E 6BT.
          </p>
          <p>
            Please note that UCL has appointed a Data Protection Officer. If you
            have any questions about this Privacy Notice, including any requests
            to exercise your legal rights, please contact our Data Protection
            Officer using the details set out below:
          </p>
          <p>
            <a href="mailto:dataprotection@ucl.ac.uk"
              >dataprotection@ucl.ac.uk</a
            >
          </p>
          <h2>How can I complain?</h2>
          <p>
            If you are not happy with the way your information is being handled,
            or with the response received from us, you have the right to lodge a
            complaint with the Information Commissioner’s Office at Wycliffe
            House, Water Lane, Wilmslow, SK9 5AF
          </p>
          <p>
            If you wish to complain about our use of personal data, please send
            an email with the details of your complaint to
            <a href="mailto:dataprotection@ucl.ac.uk"
              >dataprotection@ucl.ac.uk</a
            >
          </p>
          <p>so that we can look into the issue and respond to you.</p>
          <p>
            You also have the right to lodge a complaint with the Information
            Commissioner's Office (ICO). The UK data protection regulator.
          </p>
          <p>
            For further information on your rights and how to complain to the
            ICO, please refer to the ICO website at
            <a href="https://ico.org.uk/">https://ico.org.uk</a>
          </p>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer
  }
};
</script>
